import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ModalController, RadioGroupChangeEventDetail, ToastController } from '@ionic/angular';
import { TransactionService } from 'src/app/services/transaction.service';
import { Clipboard } from '@capacitor/clipboard';
import { VariableService } from 'src/app/services/variable.service';
import { BankPaymentMethod } from 'src/app/interfaces/api/variable';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-modal-manual-transfer-payment',
  templateUrl: './modal-manual-transfer-payment.component.html',
  styleUrls: ['./modal-manual-transfer-payment.component.scss'],
})
export class ModalManualTransferPaymentComponent implements OnInit {
  @Input() transactionId: number;
  @Input() bca_name: string;
  @Input() bca_number: string;
  @ViewChild('inputImg') inputImg: ElementRef;

  isUploadPaymentProof = false;
  uploadedImgUrl: string | SafeUrl;
  readyToUploadFile: any;
  selectedPaymentMethod: string;
  formDataReady: FormData;
  banks: BankPaymentMethod[];

  constructor(
    private modalCtrl: ModalController,
    private sanitizer: DomSanitizer,
    private transactionService: TransactionService,
    private toastController: ToastController,
    private variableService: VariableService,
  ) {}

  ngOnInit() {
    this.bca_name = this.bca_name && this.bca_name !== '' ? this.bca_name : 'TOPDEPO';
    this.bca_number = this.bca_number && this.bca_name !== '' ? this.bca_number : '3853551623';
    const banksVar = this.variableService.getBankPaymentMethods();
    forkJoin([banksVar]).subscribe({
      next: ([bankRes]) => {
        this.banks = bankRes;
      },
      complete: () => {
        // event?.target?.complete();
        // this.controllerService.dismissLoading();
      },
    });
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    this.readyToUploadFile = event.target.files[0];
    this.uploadedImgUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));

    // eslint-disable-next-line prefer-const
    let formData = new FormData();
    if (event.target.files[0] === undefined) {
      return;
    }
    formData.append('payment_proof', event.target.files[0] as any);
    this.formDataReady = formData;
  }

  uploadImage() {
    this.transactionService.uploadPaymentProof(this.transactionId, this.formDataReady).subscribe({
      next: val => {
        this.presentToast(val.message);
        this.confirmPaymentMethod(val.transaction);
      },
    });
  }

  onSelectPayment(event: Event) {
    const customEvent = event as CustomEvent<RadioGroupChangeEventDetail>;
    this.selectedPaymentMethod = customEvent.detail.value;
    console.log(this.selectedPaymentMethod);
  }

  confirmPaymentMethod(data: any) {
    return this.modalCtrl.dismiss(data, 'confirm');
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  async copyToClipboard(num) {
    await Clipboard.write({
      // eslint-disable-next-line id-blacklist
      string: num,
    });
    this.presentToast(`Successfully copy ${num} to clipboard`);
  }

  protected async presentToast(message: string, duration: number = 1000): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration,
      mode: 'ios',
    });
    return await toast.present();
  }
}
